import { render, staticRenderFns } from "./TheLoan.vue?vue&type=template&id=83450038&"
import script from "./TheLoan.vue?vue&type=script&lang=js&"
export * from "./TheLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports